import styles from './List.css'
import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import {isDirty} from 'redux-form'
import * as actItem from 'actions/library/item'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    let {items, itemDetail} = this.props

    return (items.length > 0 && <div className={styles['wrapper']}>
      <div className='full-height'>
        <div className={`${styles['leftcol']} no-padding`} id='mk-col-left'>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.headerName}>Name</th>
                <th className={styles.headerCategory}>Category</th>
                <th className={styles.headerPrice}>Price</th>
                <th className={styles.headerInStock}>In Stock</th>
                <th className={styles.headerStockAlert}>Stock Alert</th>
              </tr>
            </thead>
          </table>
          <div className={`${styles['table-content-wrapper']} item-library-table-content-wrapper`}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}>
              <table className={styles['table-content']}>
                <tbody>
                  {items.length > 0 && items.map((item) => {
                    return (<tr className={`${(itemDetail && itemDetail.id === item.id) ? styles.selected : ''}`}
                      onClick={() => this._onClickRow(item)}>
                      <td className={styles.headerName}>{item.name}</td>
                      <td className={styles.headerCategory}>{item.category.name}</td>
                      <td className={styles.headerPrice}>{this._priceFormatter(item)}</td>
                      <td className={styles.headerInStock}>{this._inStockFormatter(item)}</td>
                      <td className={styles.headerStockAlert}>{this._stockAlertFormatter(item, itemDetail)}</td>
                    </tr>)
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>)
  }

  _onClickRow = (item) => {
    const {isDirtyItem} = this.props
    if (isDirtyItem) {
      this.props.dispatch(askConfirmAction(actItem.onClickRow(item)))
    } else {
      this.props.dispatch(actItem.onClickRow(item))
    }
  };

  _onReachBottom = () => {
    let {dispatch, currentPage, items, filterState} = this.props
    dispatch(actItem.itemsRequest({page: currentPage + 1, filterState}, items))
  };

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _priceFormatter = (item) => {
    let itemVariants = item.item_variants

    if (itemVariants.length > 1) {
      return itemVariants.length + ' Prices'
    }

    if (itemVariants.length < 2 && itemVariants.length !== 0) {
      let price = itemVariants[0].price

      if (price === null) {
        return 'Variable'
      }
      return this._currencyFormatter(price)
    }
  }

  _currencyFormatter = (data) => {
    if (isNaN(data)) return 'Rp. 0'
    var currency = 'Rp. '
    var result = ''
    data = data || 0
    if (data < 0) {
      data *= -1
      result = '(' + currency + data.toString() + ')'
    } else {
      result = currency + data.toString()
    }
    return result.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
  };

  _inStockFormatter = (item) => {
    let itemVariants = item.item_variants
    let total = 0
    let count = 0

    for (let i = 0; i < itemVariants.length; i++) {
      let itemVariant = itemVariants[i]

      if (itemVariant.track_stock) {
        count += 1
        total += parseInt(itemVariant.in_stock)
      }
    }

    if (count > 0) {
      return total
    } else {
      return total === 0 ? '' : total
    }
  }

  _stockAlertFormatter = (item, itemDetail) => {
    let itemVariants = item.item_variants
    let text = ''
    let color = '#FFD700'
    let whiteColor = '#FFFFFF'
    let lowTotal = 0
    let outTotal = 0
    let counter = 0
    if (itemVariants.length > 0) {
      for (let i = 0; i < itemVariants.length; i++) {
        let itemVariant = itemVariants[i]
        if (itemVariant.track_stock && itemVariant.alert) {
          counter += 1
          if (itemVariant.in_stock <= itemVariant.stock_alert && itemVariant.in_stock > 0) {
            lowTotal += 1
          } else if (itemVariant.in_stock <= 0) {
            outTotal += 1
          }
        }
      }

      if (outTotal > 0) {
        color = '#FF0000'
      }
      // $scope.color = color;

      if (outTotal === 0 && lowTotal > 0) {
        text = lowTotal + ' Low'
      } else if (outTotal > 0 && lowTotal === 0) {
        text = outTotal + ' Out'
      } else {
        text = lowTotal + ' Low, ' + outTotal + ' Out'
      }
    }

    if (counter > 0) {
      if (outTotal > 0 || lowTotal > 0) {
        const style = {color}
        const styleWhite = {whiteColor}
        if (itemDetail && itemDetail.id === item.id) {
          return (<span style={styleWhite}>{text}</span>)
        } else {
          return (<span style={style}>{text}</span>)
        }
      }
    }

    return ''
  }
}

function mapStateToProps (state) {
  let {items, itemDetail, currentPage, totalPage, showDetail, filterState} = state.library.item
  return {
    items,
    itemDetail,
    currentPage,
    totalPage,
    showDetail,
    isDirtyItem: isDirty('item')(state),
    filterState
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  items: React.PropTypes.array,
  itemDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  showDetail: React.PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Library/Item/List/List.js